import { createReducer, on } from '@ngrx/store';
import { setDarkMode} from './theme.actions';

export interface ThemeState {
  darkMode: boolean;
}

export const initialState: ThemeState = {
  darkMode: false
};

export const themeReducer = createReducer(
  initialState,
  on(setDarkMode, (state, { darkMode }) => ({
    ...state,
    darkMode
  })),


);
